module.exports = __webpack_public_path__ + "media/images/vp/icon.submenu.organizations.red-51bc82d320f53c0d0491d8d83b4ad032.svg";